import React from 'react';
import { Typography } from 'fronton-react';
import { useRecoilValue } from 'recoil';
import { dimensionsAtom } from '../../../dimensions/store/dimensions';
import { getHintText } from '../../helpers/get-hint-text.helper';
import { HintsContainer, HintContainer, sphere } from './hints.styles';

export const HintsComponent: React.FC = () => {
  const dimensions = useRecoilValue(dimensionsAtom);
  const { hints } = dimensions;

  if (hints && hints.length) {
    return (
      <HintsContainer>
        {hints.length === 1 ? (
          <Typography variant="s" size="body_long" color="text-primary">
            {getHintText(hints[0])}
          </Typography>
        ) : (
          hints.map(hint => (
            <HintContainer key={hint}>
              <div className={sphere} />
              <Typography variant="s" size="body_long" color="text-primary">
                {getHintText(hint)}
              </Typography>
            </HintContainer>
          ))
        )}
      </HintsContainer>
    );
  }

  return null;
};
